__turbopack_context__.v({
  "body": "index-module-scss-module__BDlfmG__body",
  "counter": "index-module-scss-module__BDlfmG__counter",
  "links": "index-module-scss-module__BDlfmG__links",
  "root": "index-module-scss-module__BDlfmG__root",
});
